"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globby = require("globby");

var _globby2 = _interopRequireDefault(_globby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var expandGlobs = function expandGlobs() {
  var globs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return _globby2.default.sync([].concat(_toConsumableArray(globs), ["!**/node_modules/**", "!./node_modules/**"]), {
    dot: true
  });
};

exports.default = expandGlobs;